import SharedReportPrePayment from './SharedReportPrePayment.js';
import AcuityBooking from './AcuityBooking.js';

function Checkout(props)
{
    if (props.reportData.report_mode === 'free') return <SharedReportPrePayment reportData={props.reportData} />;
    if (props.reportData.report_mode === 'questionnaire-free') return <AcuityBooking reportData={props.reportData} />;
}

export default Checkout;